export default __webpack_public_path__ + "static/about-peter-cruwys-8af489fa1f9e99a1794d06c4e9f7984a.jpg";